/**
 * Generated runtime TestId mirror for frontend/src/pages/SchemaPolicyEdit.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const SchemaPolicyEditTestIds = {
  btnCancel: "btn-cancel",
  btnSave: "btn-save",
  inputConstraintCode: "input-constraint-code",
  inputDescription: "input-description",
  inputExpression: "input-expression",
  inputMessageTemplate: "input-message-template",
  inputName: "input-name",
  schemaPolicyEdit: "schema-policy-edit",
  selectSeverity: "select-severity",
  selectType: "select-type"
} as const;
